<template>
  <div class="flex flex-align-center">
    <PgCheckbox v-bind="$attrs" v-on="$listeners"></PgCheckbox>
    <Popover
      :placement="placement"
      :title="title"
      :width="width"
      :trigger="trigger"
      :content="content"
    >
      <i slot="reference" class="el-icon-question checkbox_question"></i>
    </Popover>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { PgCheckbox } from '../index'
import { Popover } from 'element-ui'

defineProps({
  placement: {
    type: String,
    default: 'right',
  },
  title: {
    type: String,
    default: '',
  },
  width: {
    type: Number,
    default: 200,
  },
  content: {
    type: String,
    default: '内容',
  },
  trigger: {
    type: String,
    default: 'hover',
  },
})
</script>
<style lang="scss">
.checkbox_question {
  color: var(--color-primary);
  font-size: 16px;
}
</style>
